import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
} from '@angular/forms';
import { GetLiteForGBClientDTO } from 'src/app/models/classes/client/get-lite-for-gb-client';
import { ClientSearchCriteria } from 'src/app/models/search-criterias/client-search-criteria';
import { ClientService } from 'src/app/services/client/client.service';
import { PercentageOrValue } from 'src/app/models/enums/percentage-or-value';
import { TranslateService } from '@ngx-translate/core';
import { PlaceType } from 'src/app/models/enums/place-type';
import { ABookingService } from 'src/app/services/booking/abooking.service';
import { ExecutionResponse } from 'src/app/models/support/execution-response';
import { BookingForDownPaymentDTO } from 'src/app/models/classes/booking/booking-for-down-payment';
import { GetBookingCriteria } from 'src/app/models/search-criterias/get-booking-criteria';
import { GetBookingsForDownPaymentCriteria } from 'src/app/models/search-criterias/get-bookings-for-down-payment-criteria';
import { BookingForDownPaymentDropdownDTO } from 'src/app/models/classes/booking/booking-for-down-payment-drop-down';
import { Transaction2Service } from 'src/app/dashboard/transaction/service/transaction.service';
import { SharedService } from 'src/app/services/other/shared.service';
import { AccountPayments } from 'src/app/dashboard/transaction/model/cashier-constants';
import { ResponseState } from 'src/app/models/support/response-state';
import { TransactionType } from 'src/app/models/enums/transaction-type';

@Component({
  selector: 'app-add-client-down-payment',
  templateUrl: './add-client-down-payment.component.html',
  styleUrls: ['./add-client-down-payment.component.scss'],
})
export class AddClientDownPaymentComponent implements OnInit {
  public accountPayments: any;

  GForm: UntypedFormGroup;
  TransactionsPayments: UntypedFormArray;
  CurrencyName: string;

  constructor(
    private transactionService: Transaction2Service,
    public sharedService: SharedService,
    private clientService: ClientService,
    private aBookingService: ABookingService,
    public translateService: TranslateService,
    private fb: UntypedFormBuilder
  ) {
    this.accountPayments = AccountPayments;
  }
  @Input() PaymentMainPage: boolean = true;

  @Output() LoadData = new EventEmitter();

  ngOnInit(): void {

    this.MakeTransactionValidation();
    this.GetClient();
    this.GFormData();

    this.CurrencyName =
      this.translateService.currentLang == 'ar'
        ? this.sharedService.CurrencyNameAr
        : this.sharedService.CurrencyNameEn;
  }
  /*======== MakeTransactionValidation ====================================*/
  MessageValidation;
  IsActive = true;
  MakeTransactionValidation() {
    this.transactionService
      .MakeTransactionValidation({
        AccountSetupId: this.sharedService.AccountSetupId,
      })
      .subscribe((response: any) => {
        if (response.State == ResponseState.Success) {
          console.log(response);
          this.MessageValidation = response.Message;
        } else {
          this.MessageValidation = response.Message;
          this.IsActive = false;
        }
      });
  }

  GFormData() {
    this.GForm = this.fb.group({
      TransfereToCashierId: 0,
      EmployeeId: 0,
      Transaction: this.fb.group({
        Id: 0,
        TransactionType: TransactionType.ClientDownPayment,
        TotalNetPrice: 0,
        Descreption: null,
        CashierId: 0,
        CashierShiftId: 0,
        CashierDailyId: 0,
        ClientId: null,
        EnteredById: 0,
        BookingId: null,
        TransactionStatus: 3,
        AccountSetupId: this.sharedService.AccountSetupId,
        CompanyId: this.sharedService.CompanyId,
        TransactionsPayments: this.fb.array([this.AddTransactionsPayments()]),
      }),
    });
  }

  clearClientId() {
    this.GForm.get('Transaction')
      .get('ClientId')
      .patchValue(null);
  }

  customSearchFn1(term: string, item: GetLiteForGBClientDTO) {
    term = term.toLowerCase();
    return (
      item.Name.toLowerCase().indexOf(term) > -1 ||
      item.Mobile.toLowerCase().indexOf(term) > -1 ||
      item.Mobile.toLowerCase() === term
    );
  }

  AddTransactionsPayments() {
    return this.fb.group({
      TransactionId: 0,
      PaymentTypeId: 1,
      Amount: 0,
      AmountInDefault: 0,
      CurrencyId: 0,
      AvalableCredit: null,
      AvalableClientPaymentDown: null,
      ShowAvalableCredit: false,
      ShowAvalableClientPaymentDown: null,
      showGiftcardCode: false,
      availablecredit: null,
      giftCardChoosed: false,
      voucherChoosed: false,
      giftCardCode: null,
      Code: null,
      enableCheckButton: null,
      showVisaDetailsButton: false,
      loyalityMonyChoosed: false,
      clientDownPaymentChoosed: false,
      VisaTypeId: null,
      VisaNumber: null,
      VisaTypeName: null,
      CurrencyFactor: 1,
      PaymentMethodId: 0,
      CreditCardId: null,
      ReferenceCode: null,
      GiftCardCode: null,
      GiftCardInformationId: null,
      GiftCardOTPCode: null,
      GiftCardInformationOTPId: null,
      PaymentMethodType: 0,
    });
  }

  PushTransactionsPayments() {
    this.TransactionsPayments = this.GForm.get('Transaction').get(
      'TransactionsPayments'
    ) as UntypedFormArray;
    this.TransactionsPayments.push(
      this.fb.group({
        TransactionId: 0,
        PaymentTypeId: 1,
        Amount: null,
        AmountInDefault: 0,
        CurrencyId: 0,
        AvalableCredit: null,
        AvalableClientPaymentDown: null,
        ShowAvalableCredit: false,
        ShowAvalableClientPaymentDown: null,
        showGiftcardCode: false,
        availablecredit: null,
        giftCardChoosed: false,
        voucherChoosed: false,
        giftCardCode: null,
        Code: null,
        enableCheckButton: null,
        showVisaDetailsButton: false,
        loyalityMonyChoosed: false,
        clientDownPaymentChoosed: false,
        VisaTypeId: null,
        VisaNumber: null,
        VisaTypeName: null,
        CurrencyFactor: 1,
        PaymentMethodId: 0,
        CreditCardId: null,
        ReferenceCode: null,
        GiftCardCode: null,
        GiftCardInformationId: null,
        GiftCardOTPCode: null,
        GiftCardInformationOTPId: null,
        PaymentMethodType: 0,
      })
    );
  }
  get Vform() {
    return this.GForm.controls;
  }

  removeItem(i) {
    // (this.GForm.get('cashierBalances') as FormArray).removeAt(i);
  }
  CreateData() {
    this.Create();
  }

  btnLoading = false;

  Create() {
    this.btnLoading = true;

    this.transactionService
      .CreateTransactions(this.GForm.value)
      .subscribe((response: any) => {
        if (response.State == ResponseState.Success) {
          this.LoadData.emit('get');
          this.sharedService.ToastrSuccess(response.Message);
          this.sharedService.HideModal();
          // this.GForm.reset();
          this.booking = null;
          this.GForm.get('Transaction').get('ClientId').patchValue(['']);
          this.GForm.get('Transaction').get('BookingId').patchValue(['']);
          this.GForm.get('Transaction').get('BookingId').patchValue(['']);

          const controlArray = <UntypedFormArray>(
            this.GForm.get('Transaction').get('TransactionsPayments')
          );
          controlArray.controls[0].get('Amount').patchValue(['']);
          this.btnLoading = false;
          this.downPaymentRemainingOrBookingRemaining = null;
          this.downPaymentRemainingOrBookingRemainingReal = null;
        } else {
          this.sharedService.ToastrError(response.Message);
          this.btnLoading = false;
        }
      });
  }

  data;
  getTransactionHeaderData(e) {
    console.log(e);
    this.data = e;
    console.log(e.CashierId);

    this.GForm.patchValue({
      TransfereToCashierId: this.data.CashierId,
      EmployeeId: this.data.EmployeeId,
    });
    this.GForm.get('Transaction').patchValue({
      EnteredById: this.data.EmployeeId,
      CashierDailyId: this.data.CashierDailyId,
      CashierId: this.data.CashierId,
      CashierShiftId: this.data.CashierShiftId,
    });
  }
  editState: boolean = false;
  itemToEdit;

  OpenModal(evente, item) {
    this.editState = true;
    this.itemToEdit = item;
  }
  ModelAdd() {
    this.GForm.patchValue({
      TransfereToCashierId: this.data.CashierId,
      EmployeeId: this.data.EmployeeId,
    });
    this.GForm.get('Transaction').patchValue({
      EnteredById: this.data.EmployeeId,
      CashierDailyId: this.data.CashierDailyId,
      CashierId: this.data.CashierId,
      CashierShiftId: this.data.CashierShiftId,
      TransactionType: 11,
      TransactionStatus: 3,
      AccountSetupId: this.sharedService.AccountSetupId,
      CompanyId: this.sharedService.CompanyId,
      TransactionsPayments: this.fb.array([this.AddTransactionsPayments()]),
    });
  }

  /*======== GetClient =========================================================*/
  Clients: GetLiteForGBClientDTO[];
  searchClient;
  GetClient(clientId: number = null) {
    var clientSearchCriteria: ClientSearchCriteria = new ClientSearchCriteria();
    clientSearchCriteria.AccountSetupId = this.sharedService.AccountSetupId;
    clientSearchCriteria.PagingEnabled = true;
    clientSearchCriteria.PageSize = 2;
    clientSearchCriteria.PageNumber = 0;
    clientSearchCriteria.FreeText = this.searchClient;
    clientSearchCriteria.Status = 1;
    clientSearchCriteria.Id = clientId ? clientId : null;

    this.clientService
      .GetClientsLite(clientSearchCriteria)
      .subscribe((response) => {
        if (response.State == ResponseState.Success) {
          this.Clients = response.Clients;
        }
      });
  }

  onSearch(e) {
    console.log(e);
    this.searchClient = e.term;
    this.GetClient();
  }
  /*======== GetBooking =========================================================*/
  Bookings;
  GetBooking(e, bookingId: number = null) {

    this.Bookings = [];

    if (e?.Id > 0) {

      let getBookingCriteria = new GetBookingsForDownPaymentCriteria();
      getBookingCriteria.ClientId = e.Id;
      getBookingCriteria.BookingId = bookingId ? bookingId : null;

      this.aBookingService.GetBookingsForDownPayment(getBookingCriteria).
        subscribe((response: ExecutionResponse<BookingForDownPaymentDropdownDTO[]>) => {

          if (response.State == ResponseState.Success) {

            this.Bookings = response.Result;
          }
        });

    }

  }

  downPaymentRemainingOrBookingRemaining;
  downPaymentRemainingOrBookingRemainingReal;
  downPayment = 0;
  booking;
  PushBookingDP(e) {

    this.booking = e;

    this.SetShouldPaidAmount();
  }

  SetdownPayment(e) {

    this.downPaymentRemainingOrBookingRemaining = +e.target.value;
    this.downPaymentRemainingOrBookingRemainingReal = +e.target.value;

    if (this.downPaymentRemainingOrBookingRemaining >
      this.booking.TotalNetPrice - this.booking.PaidAmount
    ) {
      var diff = this.downPaymentRemainingOrBookingRemaining -
        (this.booking.TotalNetPrice - this.booking.PaidAmount);

      if (diff > .1) {

        this.sharedService.ToastrWarning2(this.translateService.instant("DownPaymentIsBiggerThanRequired"));

      }

      let remainingText = (this.booking.TotalNetPrice - this.booking.PaidAmount).
        toFixed(this.sharedService.GetFractionRoundCount);
      let remaining = +(remainingText);

      this.downPaymentRemainingOrBookingRemaining =
        remaining;
      this.downPaymentRemainingOrBookingRemainingReal =
        this.booking.TotalNetPrice - this.booking.PaidAmount;

    }

    const controlArray = <UntypedFormArray>(
      this.GForm.get('Transaction').get('TransactionsPayments')
    );
    controlArray.controls[0]
      .get('Amount')
      .patchValue(this.downPaymentRemainingOrBookingRemainingReal);
    controlArray.controls[0]
      .get('AmountInDefault')
      .patchValue(this.downPaymentRemainingOrBookingRemainingReal);

    this.GForm.get('Transaction')
      .get('TotalNetPrice')
      .patchValue(this.downPaymentRemainingOrBookingRemainingReal);
  }

  SetShouldPaidAmount() {

    let hasDownPaymentSetting = this.sharedService?.CurrentBranch?.AllowSettingMinimumAndMaximumValueOrPercentageForDownPayment &&
      (this.sharedService?.CurrentBranch?.DownPaymentSettingApplyOn == PlaceType.OnSite ||
        this.sharedService?.CurrentBranch?.DownPaymentSettingApplyOn == PlaceType.Both);

    if (this.booking &&
      (this.booking.GymGroupsMinDownPayment || hasDownPaymentSetting)) {

      if (this.booking.GymGroupsMinDownPayment) {

        this.downPaymentRemainingOrBookingRemaining =
          this.downPaymentRemainingOrBookingRemainingReal =
          this.booking.GymGroupsMinDownPayment;
      }
      else {
        let downPaymentSettingType = this.sharedService?.CurrentBranch?.DownPaymentSettingType;
        let min = this.sharedService?.CurrentBranch?.MinDownPaymentNumber;

        if (downPaymentSettingType == PercentageOrValue.Percentage) {

          let remaining = this.booking.TotalNetPrice - this.booking.PaidAmount;

          this.downPaymentRemainingOrBookingRemaining =
            min * this.booking.TotalNetPrice * 0.01;
          this.downPaymentRemainingOrBookingRemainingReal =
            min * this.booking.TotalNetPrice * 0.01;

          if (this.downPaymentRemainingOrBookingRemaining > remaining) {

            let remainingText = remaining.
              toFixed(this.sharedService.GetFractionRoundCount);
            let remainingNumber = +(remainingText);

            this.downPaymentRemainingOrBookingRemainingReal =
              remaining;

            this.downPaymentRemainingOrBookingRemaining = remainingNumber;

          }
        }
        else if (downPaymentSettingType == PercentageOrValue.Value) {
          let remaining = this.booking.TotalNetPrice - this.booking.PaidAmount;

          this.downPaymentRemainingOrBookingRemaining = min;
          this.downPaymentRemainingOrBookingRemainingReal = min;

          if (this.downPaymentRemainingOrBookingRemaining > remaining) {

            let remainingText = remaining.
              toFixed(this.sharedService.GetFractionRoundCount);
            let remainingNumber = +(remainingText);

            this.downPaymentRemainingOrBookingRemainingReal =
              remaining;

            this.downPaymentRemainingOrBookingRemaining = remainingNumber;
          }
        }

      }


      let amountText = this.downPaymentRemainingOrBookingRemaining.
        toFixed(this.sharedService.GetFractionRoundCount);
      let amountNumber = +(amountText);

      this.downPaymentRemainingOrBookingRemaining = amountNumber;

      const controlArray = <UntypedFormArray>(
        this.GForm.get('Transaction').get('TransactionsPayments')
      );
      controlArray.controls[0]
        .get('Amount')
        .patchValue(this.downPaymentRemainingOrBookingRemainingReal);
      controlArray.controls[0]
        .get('AmountInDefault')
        .patchValue(this.downPaymentRemainingOrBookingRemainingReal);

      this.GForm.get('Transaction')
        .get('TotalNetPrice')
        .patchValue(this.downPaymentRemainingOrBookingRemainingReal);

    }

  }

  getTotal(): number {

    let total = 0;
    let taxRate = this.sharedService?.CurrentBranch?.SalesTaxRate;

    const controlArray = <UntypedFormArray>(
      this.GForm.get('Transaction').get('TransactionsPayments')
    );

    if (taxRate > 0 && controlArray && controlArray.controls &&
      controlArray.controls.length > 0) {

      for (let index = 0; index < controlArray.controls.length; index++) {
        total += controlArray.controls[index].get('Amount').value;

      }

    }

    return total;
  }
  getTaxValue(): number {

    let taxRate = this.sharedService?.CurrentBranch?.SalesTaxRate;

    let taxValue = 0;
    let total = this.getTotal();

    if (taxRate > 0 && total > 0) {
      taxValue = total - (total / (1 + (taxRate * .01)))
    }

    return taxValue;
  }
  //=========================================================

  BookingId;

  @Input()
  set SendBookingId(bookingId) {

    if (bookingId) {

      let getBookingCriteria = new GetBookingCriteria();
      getBookingCriteria.BookingId = bookingId;

      this.aBookingService.GetBookingForDownPayment(getBookingCriteria).
        subscribe((response: ExecutionResponse<BookingForDownPaymentDTO>) => {

          if (response.State == ResponseState.Success) {

            this.booking = response.Result;

            this.GForm.get('Transaction')
              .get('BookingId')
              .patchValue(this.booking?.Id);

            this.GForm.get('Transaction')
              .get('ClientId')
              .patchValue(this.booking?.ClientId);

            this.GetClient(this.booking?.ClientId);

            this.SetShouldPaidAmount();
          }
        });
    }
  }


}
